import type { RefCallback } from 'react'

/** A ref this helper may write to — a callback ref, or an object ref with a mutable `current`. */
type WritableRef<T> = RefCallback<T> | { current: T | null }

/**
 * Assign one DOM node to the positioning/internal ref plus the forwarded ref — a callback ref
 * is called, an object ref gets `.current` set. Standalone so the chat windows that merge refs
 * share the same assign-or-call preamble instead of re-inlining it.
 */
export const mergeRefs = <T>(
  node: T | null,
  target: WritableRef<T> | null | undefined,
  forwardedRef: WritableRef<T> | null | undefined
): void => {
  if (typeof target === 'function') {
    target(node)
  } else if (target) {
    target.current = node
  }
  if (typeof forwardedRef === 'function') {
    forwardedRef(node)
  } else if (forwardedRef) {
    forwardedRef.current = node
  }
}
